import { allowsCategory } from "./cookieConsent";

export const CHAT_RESET_EVENT = "wv:chat-reset";
export const CHAT_OPEN_EVENT = "wv:chat-open";

const CHAT_SESSION_ID_KEY = "wv_chat_session";
const CHAT_SESSION_STARTED_KEY = "wv_chat_session_started";
const CHAT_EMAIL_KEY = "wv_chat_email";
/** Fresh chat window at least every hour; also clears when the browser session ends. */
const CHAT_SESSION_MAX_AGE_MS = 60 * 60 * 1000;

function generateId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `wv-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

function readStoredSession() {
  if (typeof window === "undefined") return { id: null, started: 0 };

  if (allowsCategory("functional")) {
    return {
      id: sessionStorage.getItem(CHAT_SESSION_ID_KEY),
      started: Number(sessionStorage.getItem(CHAT_SESSION_STARTED_KEY) || 0),
    };
  }

  return {
    id: window.__wv_chat_ephemeral || null,
    started: Number(window.__wv_chat_ephemeral_started || 0),
  };
}

function writeStoredSession(id) {
  const started = String(Date.now());

  if (allowsCategory("functional")) {
    sessionStorage.setItem(CHAT_SESSION_ID_KEY, id);
    sessionStorage.setItem(CHAT_SESSION_STARTED_KEY, started);
    localStorage.removeItem(CHAT_SESSION_ID_KEY);
    localStorage.removeItem(CHAT_SESSION_STARTED_KEY);
    return;
  }

  window.__wv_chat_ephemeral = id;
  window.__wv_chat_ephemeral_started = Number(started);
}

function isSessionExpired({ id, started }) {
  if (!id || !started) return true;
  return Date.now() - started > CHAT_SESSION_MAX_AGE_MS;
}

function clearStoredSession() {
  if (typeof window === "undefined") return;

  sessionStorage.removeItem(CHAT_SESSION_ID_KEY);
  sessionStorage.removeItem(CHAT_SESSION_STARTED_KEY);
  localStorage.removeItem(CHAT_SESSION_ID_KEY);
  localStorage.removeItem(CHAT_SESSION_STARTED_KEY);
  localStorage.removeItem(CHAT_EMAIL_KEY);
  delete window.__wv_chat_ephemeral;
  delete window.__wv_chat_ephemeral_started;
}

function rotateStoredSession({ notify }) {
  const id = generateId();
  writeStoredSession(id);
  if (notify) {
    window.dispatchEvent(new CustomEvent(CHAT_RESET_EVENT));
  }
  return id;
}

export function getChatSessionId() {
  if (typeof window === "undefined") return generateId();

  const stored = readStoredSession();
  if (isSessionExpired(stored)) {
    return rotateStoredSession({ notify: true });
  }

  return stored.id;
}

/** Clear stored chat session so the next message starts fresh (e.g. on logout). */
export function resetChatSession() {
  if (typeof window === "undefined") return;
  clearStoredSession();
  window.dispatchEvent(new CustomEvent(CHAT_RESET_EVENT));
}

export function clearChatSessionStorage() {
  clearStoredSession();
}
